module.exports = __webpack_public_path__ + "static/media/reeferTrailer.1a599dc6.svg";